import useHttpGet from 'states/generics/useHttpGet'
import { computed } from '@vue/composition-api'
import { useStore } from 'store'

export default function useThreadList() {
  const store = useStore()

  const fetchThreadList = async () => {
    return await store.dispatch('chat/fetchThreads')
  }

  fetchThreadList()

  const threadList = computed(() => {
    return store.getters['chat/threads']
  })

  const isThreadListFetchInProgress = computed(() => {
    return store.state.chat.isThreadListFetchInProgress
  })

  return {
    threadList,
    isThreadListFetchInProgress,
    fetchThreadList,
  }
}
